import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import learningLogo from "../../assets/image/learningportal.svg";
import Error from "../../components/ui/Error";
import { usePageTitle } from "../../hooks/usePageTitle";
import { useLoginMutation } from "../../redux/features/auth/authApi";

export default function StudentLogin() {
    const location = useLocation();
    usePageTitle(`Login`);
    const [localError, setError] = useState(false);
    const [login, { data, isLoading, isError, error }] = useLoginMutation()
    const [input, setInput] = useState({
        email: "",
        password: ""
    });

    const changeHandler = (e) => {
        setInput((prev) => ({
            ...prev,
            [e.target.name]: e.target.value
        }))
    }
    const submitHandler = (e) => {
        e.preventDefault();
        setError(false)
        login({
            data: input,
            role: ((location.pathname === '/admin') || location.pathname === '/admin/') ? "admin" : "student"
        })
    }


    useEffect(() => {
        const adminRoute = !!((location.pathname === '/admin') || location.pathname === '/admin/')
        
        if(data){
            if (adminRoute && (data?.user?.role !== "admin")) {
                setError("You are not admin")
            }
            else if (!adminRoute && (data?.user?.role === "admin")) {
                setError("You are not Student")
            }
        }

    }, [data, location.pathname])

    return (
        <section className="py-6 bg-primary h-screen grid place-items-center">
            <div className="mx-auto max-w-md px-5 lg:px-0">
                <div>
                    <img className="h-12 mx-auto" src={learningLogo} alt="Lws Learning" />
                    <h2 className="mt-6 text-center text-3xl font-extrabold text-slate-100">
                        Sign in to {((location.pathname === '/admin') || location.pathname === '/admin/') ? "Admin Account" : "Student Account"}
                    </h2>
                </div>
                <form onSubmit={submitHandler} className="mt-8 space-y-6" action="#" method="POST">
                    <input type="hidden" name="remember" value="true" />
                    <div className="rounded-md shadow-sm -space-y-px">
                        <div>
                            <label htmlFor="email-address" className="sr-only">Email address</label>
                            <input id="email-address" name="email" type="email" autoComplete="email" required
                                className="login-input rounded-t-md" placeholder="Email address"
                                value={input.email}
                                onChange={changeHandler}
                            />
                        </div>
                        <div>
                            <label htmlFor="password" className="sr-only">Password</label>
                            <input id="password" name="password" type="password" autoComplete="current-password" required
                                className="login-input rounded-b-md" placeholder="Password"
                                value={input.password}
                                onChange={changeHandler}
                            />
                        </div>
                    </div>

                    <div>
                        <button type="submit"
                            className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500" disabled={isLoading}>
                            Sign in
                        </button>
                    </div>
                    {isError && <Error message={error.data} />}
                    {localError && <Error message={localError} />}

                    {((location.pathname !== '/admin') && location.pathname !== '/admin/') && <div className="flex items-center justify-center">
                        <div className="text-sm">
                            <span>Not a member yet? </span>
                            <Link to={"/register"} className="font-medium text-violet-600 hover:text-violet-500">
                                Register
                            </Link>
                        </div>
                    </div>}
                </form>
            </div>
        </section>
    )
};